/* tslint:disable */
/* eslint-disable */
export enum WorkMailSendingProviderEnum {
  Google = 'GOOGLE',
  Smtp = 'SMTP',
  Office365 = 'OFFICE365'
}
